import { A } from "@solidjs/router";

export default function NotFound() {
  return <main class="text-center mx-auto text-gray-700 p-4">Not Found</main>;
}
